import ContinueEndingRent from './ContinueEndingRent.vue';

export { ContinueEndingRent };
export default ContinueEndingRent;
